module.exports = __webpack_public_path__ + "static/media/top_banner_3.27959ddb.png";